import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../hooks/validation-group/validation-group-hook";
import CreateRmaSettingsStore from "../../stores/create-rma-settings-store";
import RequestProductStore from "../../stores/request-product-store";
import { SelectDropdown } from "../../../../components/inputs/select-dropdown/select-dropdown";
import currentPortalStore from "../../../../stores/current-portal-store";
import { C_RMA_AVAILABLE_REASONS } from "../../../../models/User";
import { GroupedOption, SelectDropdownGrouped } from "../../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    store: RequestProductStore;
    vGroup: IValidationGroup;
    createRmaSettingsStore: CreateRmaSettingsStore;
}

const ReturnReasonSelect: React.FC<IProps> = observer(({ store, vGroup, createRmaSettingsStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    const getReasonsListGroupedOptions = (): GroupedOption[] => {
        return [
            {
                category: getTranslation('CUSTOMER_FACING', pageScope),
                options: createRmaSettingsStore.getReasonsListOptions(true)
            },
            {
                category: getTranslation('INTERNAL', pageScope),
                options: createRmaSettingsStore.getReasonsListOptions(false)
            },
        ];
    };
    
    if (currentPortalStore.setting?.createRmaDefaultSettingsEditorStore.availableReturnReasons === C_RMA_AVAILABLE_REASONS.ALL) {
        return (
            <SelectDropdownGrouped
                options={getReasonsListGroupedOptions()}
                value={createRmaSettingsStore.findReasonOption(store.returnReasonId)}
                onChange={(v) => store.setReturnReason(v?.value as number)}
                required
                isSearchable={true}
                target={null}
                validationGroup={vGroup} 
                placeholder={getTranslation('SELECT_PLACEHOLDER', pageScope)}
            />
        );
    }

    return (
        <SelectDropdown
            options={createRmaSettingsStore.getReasonsListOptions(true)}
            value={createRmaSettingsStore.findReasonOption(store.returnReasonId)}
            onChange={(v) => store.setReturnReason(v?.value as number)}
            required
            isSearchable={true}
            validationGroup={vGroup}
            target={null}
        />
    );
});

export default ReturnReasonSelect;